<template>
  <section class="office-faq">
    <h2 class="section-title">{{ $t('office.faq.title') }}</h2>
    <div class="faq-container">
      <div v-for="(item, index) in faqItems" :key="index" class="faq-item" :class="{ 'is-expanded': expanded === index }">
        <button class="faq-question" @click="toggleFAQ(index)">
          <span class="question-text">{{ item.question }}</span>
          <Icon name="material-symbols:expand-more" class="expand-icon" :class="{ 'is-rotated': expanded === index }" />
        </button>
        <div class="faq-answer" v-show="expanded === index">
          <div class="answer-content">
            <div class="answer-text" v-html="item.answer"></div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

const faqItems = computed(() => ([
  { question: t('office.faq.items.0.q'), answer: t('office.faq.items.0.a') },
  { question: t('office.faq.items.1.q'), answer: t('office.faq.items.1.a') },
  { question: t('office.faq.items.2.q'), answer: t('office.faq.items.2.a') },
  { question: t('office.faq.items.3.q'), answer: t('office.faq.items.3.a') }
]))

const expanded = ref<number | null>(null)
function toggleFAQ(index: number) {
  expanded.value = expanded.value === index ? null : index
}
</script>

<style scoped>
.office-faq {
  padding: 4rem 0;
}

.section-title {
  text-align: center;
  font-size: 2rem;
  color: #2c3e50;
  margin-bottom: 3rem;
}

.faq-container {
  width: 100%;
  max-width: none;
  margin: 0 auto;
  padding: 0 1rem;
}

.faq-item {
  border: 1px solid #e9ecef;
  border-radius: 8px;
  margin-bottom: 1rem;
  overflow: hidden;
}

.faq-question {
  width: 100%;
  padding: 1.5rem;
  background: none;
  border: none;
  text-align: left;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 1.1rem;
  font-weight: 600;
  color: #2c3e50;
}

.faq-question:hover {
  background-color: #f8f9fa;
}

.expand-icon {
  font-size: 1.5rem;
  color: #4A90E2;
  transition: transform 0.3s ease;
}

.expand-icon.is-rotated {
  transform: rotate(180deg);
}

.faq-answer {
  border-top: 1px solid #e9ecef;
}

.answer-content {
  padding: 1.5rem;
}

.answer-text {
  color: #495057;
  line-height: 1.6;
}

.answer-text :deep(strong) {
  color: #4A90E2;
  font-weight: 600;
}
</style>
